import axios from 'axios';
import axiosRetry from 'axios-retry';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';

// FIX (FRONTEND-BUG-004): Enforce HTTPS in production
if (import.meta.env.PROD && !API_BASE_URL.startsWith('https://')) {
    console.error('❌ SECURITY ERROR: API must use HTTPS in production!');
    throw new Error('Production API URL must use HTTPS. Current: ' + API_BASE_URL);
}

// Create axios instance with default config
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000, // 30 seconds
});

// FIX (FRONTEND-ISSUE-001): Add retry logic for failed API calls
axiosRetry(api, {
    retries: 3,
    retryDelay: axiosRetry.exponentialDelay,
    retryCondition: (error) => {
        // Retry on network errors or 5xx server errors
        return axiosRetry.isNetworkOrIdempotentRequestError(error) ||
            (error.response?.status >= 500 && error.response?.status < 600);
    },
});

// Request interceptor - add JWT token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('jwt_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - handle 401 and auto-logout
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // FIX (FRONTEND-BUG-007): Use event instead of window.location to avoid redirect loop
            // Clear token
            localStorage.removeItem('jwt_token');

            // Dispatch custom event instead of immediate redirect
            // This prevents multiple concurrent 401s from causing reload loops
            window.dispatchEvent(new CustomEvent('auth:logout'));

            // If we're not already on login page, navigate there
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
